import OfferingListItem from "../offering-list-item";

const OptionListItem = ({ option }) => {
  return (
    <OfferingListItem
      href={`/options/${option.slug}`}
      name={option.name}
      mobileName={option.mobileName}
      subtitle={option.subtitle}
      image={option.image}
      roomSize={option.roomSize}
    />
  );
};

export default OptionListItem;
